// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"58977f58","821":"9ef5b67f","830":"c0d33e99"}[chunkId] + ".chunk.js";
};